import type { RecipeCalculationType, RecipePrioritizationType } from '../../../../recipe/models';

export const getRecipeCalculationLabel = (calculation: {
    calculationType: RecipeCalculationType;
    prioritizationType: RecipePrioritizationType | null;
}) => {
    const { calculationType, prioritizationType } = calculation;

    if (prioritizationType === 'organic') {
        return 'Eko';
    }

    if (calculationType === 'price') {
        return 'Billigt';
    }

    if (calculationType === 'waste') {
        return 'Rekommenderat';
    }
};
